import {
  categoryTypes,
  commonTypes,
  itemTypes,
  orderTypes,
  tableTypes,
  userTypes,
  utilTypes,
} from "../types";
import price from "../../helpers/calculatePrice";
import { ITEMSTATUS } from "../../contants";

export const findActiveOrderIndex = (activeOrders, refId) => {
  if (!activeOrders || !Array.isArray(activeOrders)) return null;
  const foundOrder = activeOrders.findIndex((order) => order.refId === refId);
  if (foundOrder > -1) {
    return foundOrder;
  } else {
    return null;
  }
};

export const isThatItemInMyOrder = (activeOrder, myItemId, index) => {
  if (typeof index === "undefined") {
    return activeOrder.orderItems.find(
      (d) => (d.itemId || d.id || d._id) === myItemId,
    );
  }
  return activeOrder.KOTS[index].orderItems.find(
    (d) => (d.itemId || d.id || d._id) === myItemId,
  );
};

export const checkIfQuantityExceeds = (item, quantity) => {
  if (item.isQuantityChecked && item.currentStock >= 0) {
    if (quantity > item.currentStock) {
      alert("Not Enought Quantity");
      return true;
    }
    return false;
  } else {
    return false;
  }
};

export const findItemIndex = (orderItems, itemId) => {
  const foundOrder = orderItems.findIndex((order) => order.itemId === itemId);
  if (foundOrder > -1) {
    return foundOrder;
  } else {
    return undefined;
  }
};

// ✅ Immutable: returns a new activeOrders array without mutating the original
export const pushItemToActiveOrderRedux = ({ activeOrders, refId, item }) => {
  const myOrder = findActiveOrderIndex(activeOrders, refId);
  if (myOrder >= 0) {
    const order = activeOrders[myOrder];
    const kots = Array.isArray(order.KOTS) ? order.KOTS : [];
    const lastKotIndex = kots.length - 1;
    const lastKot = lastKotIndex >= 0 ? kots[lastKotIndex] : null;
    const needNewKot = !lastKot || (lastKot.statusId !== undefined && lastKot.statusId > 0);
    const resolvedItemId = (item?.variantId || item?.itemId || item?._id || item?.id)?.toString();

    // Remove from deletedItemIds if it was previously marked deleted
    const updatedDeletedIds = (order.deletedItemIds || []).filter((entry) => {
      const id = typeof entry === "object" ? entry.id : entry;
      return id?.toString() !== resolvedItemId;
    });

    const existingIndex = order.orderItems.findIndex(
      (a) => (a.itemId || a.id || a._id)?.toString() === resolvedItemId
    );

    let updatedOrderItems;
    let updatedKOTS;
    const updateTime = Date.now();

    if (existingIndex >= 0) {
      const existingItem = order.orderItems[existingIndex];
      const newQty = (existingItem.quantity || 1) + 1;
      const unitPrice =
        existingItem.itemPrice ||
        (existingItem.quantity ? existingItem.itemTotal / existingItem.quantity : 0);
      const newItemTotal = newQty * unitPrice;

      updatedOrderItems = order.orderItems.map((it, idx) =>
        idx === existingIndex
          ? { ...it, quantity: newQty, itemTotal: newItemTotal, lastUpdated: updateTime }
          : it
      );

      if (needNewKot) {
        const newKot = {
          status: "Kot Pending",
          statusId: 0,
          orderItems: [{ ...item, quantity: 1, itemTotal: unitPrice, lastUpdated: updateTime }],
        };
        updatedKOTS = [...kots, newKot];
      } else {
        const existingKotIndex = (lastKot?.orderItems || []).findIndex(
          (it) => (it.itemId || it.id || it._id)?.toString() === resolvedItemId
        );
        updatedKOTS = kots.map((kot, kIdx) => {
          if (kIdx !== lastKotIndex) return kot;
          if (existingKotIndex >= 0) {
            return {
              ...kot,
              orderItems: kot.orderItems.map((it, idx) =>
                idx === existingKotIndex
                  ? { ...it, quantity: (it.quantity || 1) + 1, itemTotal: ((it.quantity || 1) + 1) * unitPrice, lastUpdated: updateTime }
                  : it
              ),
            };
          } else {
            return {
              ...kot,
              orderItems: [...(kot.orderItems || []), { ...item, quantity: 1, itemTotal: unitPrice, lastUpdated: updateTime }],
            };
          }
        });
      }
    } else {
      updatedOrderItems = [...order.orderItems, { ...item, lastUpdated: updateTime }];
      if (needNewKot) {
        const newKot = {
          status: "Kot Pending",
          statusId: 0,
          orderItems: [{ ...item, lastUpdated: updateTime }],
        };
        updatedKOTS = [...kots, newKot];
      } else {
        updatedKOTS = kots.map((kot, i) =>
          i === lastKotIndex
            ? { ...kot, orderItems: [...(kot.orderItems || []), { ...item, lastUpdated: updateTime }] }
            : kot
        );
      }
    }

    const updatedOrder = {
      ...order,
      _rev: (order._rev || 0) + 1,
      deletedItemIds: updatedDeletedIds,
      orderItems: updatedOrderItems,
      KOTS: updatedKOTS,
    };

    return [
      ...activeOrders.slice(0, myOrder),
      updatedOrder,
      ...activeOrders.slice(myOrder + 1),
    ];
  } else {
    alert("Please select order type");
    return activeOrders;
  }
};

// ✅ Immutable version
export const pushItemToActiveOrderSocket = ({ activeOrders, refId, item }) => {
  const myOrder = findActiveOrderIndex(activeOrders, refId);
  if (myOrder >= 0) {
    const order = activeOrders[myOrder];
    const incomingId = (item?.variantId || item?.itemId || item?._id || item?.id)?.toString();
    const alreadyExists = order.orderItems.some((existing) => {
      const existingId = (existing?.variantId || existing?.itemId || existing?._id || existing?.id)?.toString();
      return existingId === incomingId;
    });
    if (alreadyExists) {
      return activeOrders;
    }

    const updatedOrder = {
      ...order,
      orderItems: [...order.orderItems, { ...item }],
    };

    return [
      ...activeOrders.slice(0, myOrder),
      updatedOrder,
      ...activeOrders.slice(myOrder + 1),
    ];
  } else {
    alert("Please select order type");
    return activeOrders;
  }
};

// ✅ Immutable version
export const changeItemQuantityRedux = ({
  activeOrders,
  refId,
  quantity,
  targetQuantity,
  itemId,
  tableType,
  index,
}) => {
  const myOrderIndex = findActiveOrderIndex(activeOrders, refId);
  if (myOrderIndex >= 0) {
    const order = activeOrders[myOrderIndex];
    const resolvedItemId = (itemId || "")?.toString();

    const foundItem = order.orderItems.findIndex(
      (a) => (a.itemId || a.id || a._id)?.toString() === resolvedItemId
    );
    const targetIndex =
      typeof index !== "undefined" && order.KOTS[index]
        ? index
        : Math.max(0, order.KOTS.length - 1);

    const foundKotItem =
      order.KOTS[targetIndex]?.orderItems.findIndex(
        (a) => (a.itemId || a.id || a._id)?.toString() === resolvedItemId
      ) ?? -1;

    const currentQty =
      foundItem >= 0 ? order.orderItems[foundItem].quantity : 1;
    const newQuantity =
      typeof targetQuantity !== "undefined" && targetQuantity !== null
        ? targetQuantity
        : Math.max(1, currentQty + (quantity || 0));

    const itemPrice =
      foundItem >= 0 ? price(tableType, order.orderItems[foundItem]) : 0;
    const newItemTotal = newQuantity * itemPrice;
    const updateTime = Date.now();

    const updatedOrderItems = order.orderItems.map((item, i) =>
      i === foundItem
        ? {
            ...item,
            quantity: newQuantity,
            itemTotal: newItemTotal,
            lastUpdated: updateTime,
          }
        : item
    );

    const updatedKOTS = order.KOTS.map((kot, i) =>
      i === targetIndex
        ? {
            ...kot,
            orderItems: kot.orderItems.map((item, j) =>
              j === foundKotItem
                ? {
                    ...item,
                    quantity: newQuantity,
                    itemTotal: newItemTotal,
                    lastUpdated: updateTime,
                  }
                : item
            ),
          }
        : kot
    );

    const updatedOrder = {
      ...order,
      _rev: (order._rev || 0) + 1,
      orderItems: updatedOrderItems,
      KOTS: updatedKOTS,
    };

    return [
      ...activeOrders.slice(0, myOrderIndex),
      updatedOrder,
      ...activeOrders.slice(myOrderIndex + 1),
    ];
  } else {
    alert("Please select order type");
    return activeOrders;
  }
};

// ✅ Immutable version
export const saveItemAsPreparedRedux = ({ activeOrders, refId, itemId }) => {
  const myOrderIndex = findActiveOrderIndex(activeOrders, refId);

  if (myOrderIndex >= 0) {
    const order = activeOrders[myOrderIndex];
    const foundItem = order.orderItems.findIndex((a) => a.itemId === itemId);

    const updatedOrderItems = order.orderItems.map((item, i) =>
      i === foundItem
        ? {
            ...item,
            itemStatus: ITEMSTATUS[2].key,
            itemStatusId: ITEMSTATUS[2].value,
          }
        : item,
    );

    const updatedOrder = { ...order, orderItems: updatedOrderItems };

    return [
      ...activeOrders.slice(0, myOrderIndex),
      updatedOrder,
      ...activeOrders.slice(myOrderIndex + 1),
    ];
  } else {
    alert("Please select order type");
    return activeOrders;
  }
};

// ✅ Immutable version
export const removeItemRedux = ({
  activeOrders,
  refId,
  itemId,
  index,
}) => {
  const myOrderIndex = findActiveOrderIndex(activeOrders, refId);
  if (myOrderIndex >= 0) {
    const order = activeOrders[myOrderIndex];
    const resolvedId = (itemId || "")?.toString();

    // 1. Filter item from KOTS
    const updatedKOTS = order.KOTS.map((kot, i) =>
      typeof index === "undefined" || index === null || i === index
        ? {
            ...kot,
            orderItems: (kot.orderItems || []).filter((a) => {
              const currentId = (a.itemId || a.id || a._id)?.toString();
              return currentId !== resolvedId;
            }),
          }
        : kot
    );

    // 2. Rebuild orderItems strictly from updatedKOTS
    const itemMap = new Map();
    updatedKOTS.forEach((kot) => {
      kot.orderItems?.forEach((item) => {
        const key = (item.itemId || item.id || item._id)?.toString();
        if (key) {
          if (itemMap.has(key)) {
            const existing = itemMap.get(key);
            existing.quantity += item.quantity;
            existing.itemTotal = (existing.itemTotal || 0) + (item.itemTotal || 0);
          } else {
            itemMap.set(key, { ...item });
          }
        }
      });
    });
    const updatedOrderItems = Array.from(itemMap.values());

    // 3. Track deleted ID with TTL (30s) so delayed server packets do not resurrect it
    const now = Date.now();
    const updatedDeletedIds = [
      ...(order.deletedItemIds || []).filter((entry) => {
        const entryId = typeof entry === "object" ? entry.id : entry;
        return entryId?.toString() !== resolvedId;
      }),
      { id: resolvedId, ts: now },
    ];

    const updatedOrder = {
      ...order,
      _rev: (order._rev || 0) + 1,
      deletedItemIds: updatedDeletedIds,
      orderItems: updatedOrderItems,
      KOTS: updatedKOTS,
    };

    return [
      ...activeOrders.slice(0, myOrderIndex),
      updatedOrder,
      ...activeOrders.slice(myOrderIndex + 1),
    ];
  } else {
    alert("Please select order type");
    return activeOrders;
  }
};

// ✅ Immutable version
const changeMiscDetails = (activeOrders, refId, data, variable) => {
  const targetRefId =
    refId || (data && typeof data === "object" ? data.refId : null);
  const myOrderIndex = findActiveOrderIndex(activeOrders, targetRefId);

  if (myOrderIndex >= 0) {
    const order = activeOrders[myOrderIndex];
    let updatedFields = {};

    if (data !== null && typeof data === "object") {
      if (data.discount !== undefined) {
        updatedFields.discount = parseFloat(data.discount) || 0;
      }
      if (data.discountPercentage !== undefined) {
        updatedFields.discountPercentage =
          parseFloat(data.discountPercentage) || 0;
      }
      if (data.otherCharges !== undefined) {
        updatedFields.otherCharges = parseFloat(data.otherCharges) || 0;
      }
    } else {
      updatedFields[variable] = parseFloat(data) || 0;
    }

    const updatedOrder = {
      ...order,
      ...updatedFields,
      _rev: (order._rev || 0) + 1,
    };

    return [
      ...activeOrders.slice(0, myOrderIndex),
      updatedOrder,
      ...activeOrders.slice(myOrderIndex + 1),
    ];
  } else {
    return activeOrders;
  }
};

// ✅ Immutable version
export const addCustomerNameOrMobileToOrder = ({
  activeOrders,
  refId,
  data,
}) => {
  const myOrder = findActiveOrderIndex(activeOrders, refId);

  if (myOrder >= 0) {
    const updatedOrder = {
      ...activeOrders[myOrder],
      customerName: data?.customerName,
      customerMobile: data?.customerMobile,
    };

    return [
      ...activeOrders.slice(0, myOrder),
      updatedOrder,
      ...activeOrders.slice(myOrder + 1),
    ];
  } else {
    alert("Please select order type");
    return activeOrders;
  }
};

// ✅ Immutable & reconciled KOT update: preserves tombstones and in-flight changes
const setKOTITEMSDATA = (activeOrders, refId, order) => {
  if (!order) return activeOrders;
  const myOrder = findActiveOrderIndex(activeOrders, refId);
  if (myOrder < 0) return activeOrders;
  return setTableOrderData(activeOrders, refId, order, null);
};

// ✅ Reconciled update: prevents rubber-banding by preserving local in-flight edits and tombstones
const setTableOrderData = (
  activeOrders,
  refId,
  incomingOrder,
  incomingRev,
) => {
  if (!incomingOrder) return activeOrders;
  const targetRefId = refId || incomingOrder.refId;
  const myOrder = findActiveOrderIndex(activeOrders, targetRefId);
  if (myOrder === null || myOrder < 0) {
    return activeOrders;
  }

  const currentOrder = activeOrders[myOrder];
  if (!currentOrder) return activeOrders;

  // 1. Stale revision guard: drop intermediate responses from older calls
  if (
    typeof incomingRev === "number" &&
    typeof currentOrder._rev === "number" &&
    incomingRev < currentOrder._rev
  ) {
    return activeOrders;
  }

  // 2. Tombstone filter (30s TTL)
  const TOMBSTONE_TTL_MS = 30_000;
  const now = Date.now();
  const deletedIds = new Set();
  const validDeletedItemIds = [];

  (currentOrder.deletedItemIds || []).forEach((entry) => {
    if (!entry) return;
    const id = typeof entry === "object" ? entry.id?.toString() : entry?.toString();
    const ts = typeof entry === "object" ? entry.ts : undefined;
    if (id && (ts === undefined || now - ts < TOMBSTONE_TTL_MS)) {
      deletedIds.add(id);
      validDeletedItemIds.push(entry);
    }
  });

  // Map of current local items
  const currentItemsMap = new Map();
  (currentOrder.orderItems || []).forEach((item) => {
    const id = (item.itemId || item._id || item.id)?.toString();
    if (id) currentItemsMap.set(id, item);
  });

  // Reconcile orderItems: filter out deleted items, preserve local in-flight modifications
  const incomingItemIds = new Set();
  const reconciledOrderItems = (incomingOrder.orderItems || [])
    .filter((serverItem) => {
      const id = (serverItem.itemId || serverItem._id || serverItem.id)?.toString();
      return id && !deletedIds.has(id);
    })
    .map((serverItem) => {
      const id = (serverItem.itemId || serverItem._id || serverItem.id)?.toString();
      if (id) incomingItemIds.add(id);
      const localItem = id ? currentItemsMap.get(id) : null;
      if (localItem && currentOrder._rev && incomingRev && incomingRev < currentOrder._rev) {
        return localItem;
      }
      return serverItem;
    });

  // Preserve any locally added items still in-flight
  const localPendingItems = (currentOrder.orderItems || []).filter((item) => {
    const id = (item.itemId || item._id || item.id)?.toString();
    return id && !incomingItemIds.has(id) && !deletedIds.has(id);
  });

  // Reconcile KOTS
  const reconciledKOTS = (incomingOrder.KOTS || []).map((serverKot, kotIdx) => {
    const localKot = currentOrder.KOTS?.[kotIdx];
    const localKotItemsMap = new Map();
    if (localKot) {
      (localKot.orderItems || []).forEach((it) => {
        const id = (it.itemId || it._id || it.id)?.toString();
        if (id) localKotItemsMap.set(id, it);
      });
    }

    const serverKotItemIds = new Set();
    const mergedKotOrderItems = (serverKot.orderItems || [])
      .filter((serverItem) => {
        const id = (serverItem.itemId || serverItem._id || serverItem.id)?.toString();
        return id && !deletedIds.has(id);
      })
      .map((serverItem) => {
        const id = (serverItem.itemId || serverItem._id || serverItem.id)?.toString();
        if (id) serverKotItemIds.add(id);
        const localItem = id ? localKotItemsMap.get(id) : null;
        if (localItem && currentOrder._rev && incomingRev && incomingRev < currentOrder._rev) {
          return localItem;
        }
        return serverItem;
      });

    const localPendingKotItems = localKot
      ? (localKot.orderItems || []).filter((it) => {
          const id = (it.itemId || it._id || it.id)?.toString();
          return id && !serverKotItemIds.has(id) && !deletedIds.has(id);
        })
      : [];

    return {
      ...serverKot,
      orderItems: [...mergedKotOrderItems, ...localPendingKotItems],
    };
  });

  const mergedOrder = {
    ...incomingOrder,
    _rev: Math.max(currentOrder._rev || 0, incomingRev || 0),
    deletedItemIds: validDeletedItemIds,
    orderItems: [...reconciledOrderItems, ...localPendingItems],
    KOTS: reconciledKOTS,
    discount: currentOrder.discount !== undefined ? currentOrder.discount : incomingOrder.discount,
    discountPercentage: currentOrder.discountPercentage !== undefined ? currentOrder.discountPercentage : incomingOrder.discountPercentage,
    otherCharges: currentOrder.otherCharges !== undefined ? currentOrder.otherCharges : incomingOrder.otherCharges,
    customerName: currentOrder.customerName || incomingOrder.customerName,
    customerMobile: currentOrder.customerMobile || incomingOrder.customerMobile,
    remarks: currentOrder.remarks || incomingOrder.remarks,
  };

  const isItemsUnchanged =
    (currentOrder.orderItems || []).length === (mergedOrder.orderItems || []).length &&
    (currentOrder.orderItems || []).every((localIt, idx) => {
      const mergedIt = mergedOrder.orderItems[idx];
      if (!mergedIt) return false;
      const localId = (localIt.itemId || localIt._id || localIt.id)?.toString();
      const mergedId = (mergedIt.itemId || mergedIt._id || mergedIt.id)?.toString();
      return (
        localId === mergedId &&
        localIt.quantity === mergedIt.quantity &&
        localIt.itemStatus === mergedIt.itemStatus
      );
    });

  const isMetadataUnchanged =
    currentOrder.discount === mergedOrder.discount &&
    currentOrder.discountPercentage === mergedOrder.discountPercentage &&
    currentOrder.otherCharges === mergedOrder.otherCharges &&
    currentOrder.customerName === mergedOrder.customerName &&
    currentOrder.customerMobile === mergedOrder.customerMobile &&
    currentOrder.remarks === mergedOrder.remarks &&
    (currentOrder.KOTS || []).length === (mergedOrder.KOTS || []).length;

  if (isItemsUnchanged && isMetadataUnchanged) {
    return activeOrders;
  }

  return [
    ...activeOrders.slice(0, myOrder),
    mergedOrder,
    ...activeOrders.slice(myOrder + 1),
  ];
};

export const reconcileActiveOrdersList = (
  currentActiveOrders,
  incomingOrders,
) => {
  if (!Array.isArray(incomingOrders)) return currentActiveOrders || [];
  if (!Array.isArray(currentActiveOrders) || currentActiveOrders.length === 0) {
    return incomingOrders;
  }

  const currentOrdersMap = new Map();
  currentActiveOrders.forEach((order) => {
    if (order?.refId) {
      currentOrdersMap.set(order.refId, order);
    }
  });

  const incomingRefIds = new Set();
  const mergedOrders = incomingOrders.map((incomingOrder) => {
    if (!incomingOrder?.refId) return incomingOrder;
    incomingRefIds.add(incomingOrder.refId);
    const localOrder = currentOrdersMap.get(incomingOrder.refId);
    if (!localOrder) return incomingOrder;

    const reconciledList = setTableOrderData(
      [localOrder],
      incomingOrder.refId,
      incomingOrder,
      incomingOrder._rev || null,
    );
    return (reconciledList && reconciledList[0]) || localOrder;
  });

  // Preserve local orders that have in-flight items or local revisions
  currentActiveOrders.forEach((localOrder) => {
    if (localOrder?.refId && !incomingRefIds.has(localOrder.refId)) {
      if (
        (localOrder.orderItems && localOrder.orderItems.length > 0) ||
        localOrder._rev
      ) {
        mergedOrders.push(localOrder);
      }
    }
  });

  if (
    mergedOrders.length === currentActiveOrders.length &&
    mergedOrders.every((order, idx) => order === currentActiveOrders[idx])
  ) {
    return currentActiveOrders;
  }

  return mergedOrders;
};

const updateOrderStatus = (orders, data) => {
  const foundOrder = orders.findIndex((od) => od.refId === data.refId);
  if (foundOrder >= 0) {
    const existingOrderItems = orders[foundOrder].orderItems || [];

    const mergedOrderItems =
      data.orderItems?.map((newItem) => {
        const existingItem = existingOrderItems.find(
          (oldItem) =>
            (oldItem._id && oldItem._id === newItem._id) ||
            (oldItem.id && oldItem.id === newItem.id) ||
            oldItem.itemName === newItem.itemName,
        );
        return existingItem ? { ...existingItem, ...newItem } : newItem;
      }) || [];

    const updatedOrder = {
      ...orders[foundOrder],
      ...data,
      orderTypeId: parseInt(data.orderTypeId),
      orderItems: mergedOrderItems,
      tablePrice: data?.tablePrice || 0,
    };

    return [
      ...orders.slice(0, foundOrder),
      updatedOrder,
      ...orders.slice(foundOrder + 1),
    ];
  }
  return orders;
};

const deleteLocalOrder = (activeOrders, refId) => {
  return activeOrders.filter((order) => order.refId !== refId);
};

const initialstate = {
  tableTypes: [],
  allTables: [],
  activeOrders: [],
  activeOrder: undefined,
  itemCategories: [],
  allItems: [],
  lastOrderNumber: 0,
  selectedOrderType: "Dine In",
  selectedOrderTypeId: 0,
  previousOrders: [],
  orderNumberCount: 0,
  syncedOrders: [],
  unSyncedOrders: [],
  syncingProgress: 0,
  kotNumber: 0,
};

const orderReducer = (state = initialstate, action) => {
  const getData = () => action.payload?.data;
  const getPayload = () => action.payload;

  switch (action.type) {
    case orderTypes.GET_SOCKET_ORDERS:
      return {
        ...state,
        activeOrders: reconcileActiveOrdersList(
          state.activeOrders,
          action.payload || [],
        ),
      };
    case "SET_TABLE_ORDER_INFO": {
      const incomingOrder = getData() || getPayload();
      return {
        ...state,
        activeOrders: setTableOrderData(
          state.activeOrders,
          incomingOrder?.refId,
          incomingOrder,
          action.payload?.clientRev,
        ),
      };
    }
    case "GET_KOT_NUMBER":
      return {
        ...state,
        kotNumber: action.payload,
      };
    case userTypes.LOGIN_USER_SUCCESS:
      return {
        ...state,
        lastOrderNumber: action.payload.data.user.orderNumber || 0,
      };

    case userTypes.GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        lastOrderNumber: action.payload.data.user.orderNumber || 0,
      };

    case commonTypes.GET_ALL_TABLETYPES_SUCCESS:
      return {
        ...state,
        tableTypes: action.payload.data.data,
      };

    case categoryTypes.GET_BRANCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        itemCategories: getData().data,
      };

    case itemTypes.GET_BRANCH_ITEMS_SUCCESS:
      return {
        ...state,
        allItems: getData().data,
      };

    case tableTypes.GET_ALL_TABLES_SUCCESS:
      return {
        ...state,
        allTables: getData().data.map((item) => {
          return { ...item, active: false };
        }),
      };

    case orderTypes.GET_PREVIOS_ORDERS_SUCCESS:
      return {
        ...state,
        previousOrders: getData().data,
      };

    case orderTypes.GET_SOKCET_ORDERS_SUCCESS:
      return {
        ...state,
        activeOrders: reconcileActiveOrdersList(
          state.activeOrders,
          getData().data || [],
        ),
      };

    case orderTypes.SET_ACTIVE_ORDER:
      return {
        ...state,
        activeOrder: action.payload,
      };

    case orderTypes.SET_ORDER_TYPE:
      return {
        ...state,
        selectedOrderType: getPayload().key,
        selectedOrderTypeId: getPayload().value,
      };

    case orderTypes.ACTIVATE_ORDER:
      return {
        ...state,
        activeOrders: [...state.activeOrders, getPayload()],
        activeOrder: getPayload().refId,
      };
    case orderTypes.ACTIVATE_ORDER_SOCKET:
      return {
        ...state,
        activeOrders: [...state.activeOrders, getPayload()],
        activeOrder: getPayload().refId,
      };

    case orderTypes.PUSH_ITEM_TO_ORDER:
      return {
        ...state,
        activeOrders: pushItemToActiveOrderRedux({
          activeOrders: state.activeOrders,
          refId: getPayload().refId,
          item: getPayload().item,
        }),
      };

    case orderTypes.PUSH_ITEM_TO_ORDER_SOCKET:
      return {
        ...state,
        activeOrders: pushItemToActiveOrderSocket({
          activeOrders: state.activeOrders,
          refId: getPayload().refId,
          item: getPayload().item,
        }),
      };

    case orderTypes.CHANGE_ITEM_QUANTITY:
      return {
        ...state,
        activeOrders: changeItemQuantityRedux({
          activeOrders: state.activeOrders,
          refId: getPayload()?.refId,
          quantity: getPayload()?.quantity,
          targetQuantity: getPayload()?.targetQuantity,
          itemId: getPayload()?.itemId,
          tableType: getPayload()?.tableType,
          index: getPayload()?.index,
        }),
      };

    case orderTypes.SET_ITEM_AS_PREPARED_SOCKET:
      return {
        ...state,
        activeOrders: [...action.payload],
      };

    case orderTypes.REMOVE_ITEM:
      return {
        ...state,
        activeOrders: removeItemRedux({
          activeOrders: state.activeOrders,
          refId: getPayload().refId,
          itemId: getPayload().itemId,
          index: getPayload().index,
        }),
      };

    case orderTypes.SET_DISCOUNT:
      return {
        ...state,
        activeOrders: changeMiscDetails(
          state.activeOrders,
          state.activeOrder,
          action.payload,
          "discount",
        ),
      };

    case orderTypes.SET_OTHER_CHARGES:
      return {
        ...state,
        activeOrders: changeMiscDetails(
          state.activeOrders,
          state.activeOrder,
          action.payload,
          "otherCharges",
        ),
      };

    case orderTypes.SET_KOT_ITEMS:
      return {
        ...state,
        activeOrders: setKOTITEMSDATA(
          state.activeOrders,
          action.payload.refId,
          action.payload.order,
        ),
      };

    case utilTypes.SET_KOT_PRINT_DATA:
      if (action.payload.customerName || action.payload.customerMobile) {
        return {
          ...state,
          activeOrders: addCustomerNameOrMobileToOrder({
            activeOrders: state.activeOrders,
            refId: state.activeOrder,
            data: getPayload(),
          }),
        };
      }
      return {
        ...state,
      };

    case orderTypes.CONFIRM_ORDER_SUCCESS:
      return {
        ...state,
        activeOrders: updateOrderStatus(state.activeOrders, getData().data),
        lastOrderNumber: getData().data.orderNumber,
      };

    case orderTypes.UPDATE_ORDER_SUCCESS:
      return {
        ...state,
        lastOrderNumber: getData().data.orderNumber,
      };

    case orderTypes.DELETE_LOCAL_ORDER:
      return {
        ...state,
        activeOrders: deleteLocalOrder(
          state.activeOrders,
          action.payload.refId,
        ),
        orderNumberCount: state.orderNumberCount - 1,
      };

    case orderTypes.INCREMENT_ORDER_NUMBER_COUNT:
      return {
        ...state,
        orderNumberCount: state.orderNumberCount + 1,
      };

    case "OFFLINE_ACTIVE_ORDERS":
      return {
        ...state,
        activeOrders: action.payload || [],
      };

    case "OFFLINE_ACTIVATED_ORDER":
      return {
        ...state,
        activeOrders: (action.payload && action.payload.activeOrders) || [],
        activeOrder: action.payload && action.payload.refId,
      };

    case "OFFLINE_ALL_ITEMS":
      return {
        ...state,
        allItems: action.payload,
      };

    case "OFFLINE_ALL_TABLES":
      return {
        ...state,
        allTables: action.payload.map((item) => {
          return { ...item, active: false };
        }),
      };

    case "OFFLINE_ITEM_CATEGORIES":
      return {
        ...state,
        itemCategories: action.payload,
      };

    case "OFFLINE_LAST_ORDER_NUMBER":
      return {
        ...state,
        lastOrderNumber: action.payload,
      };

    case "SYNECED_ORDERS":
      return {
        ...state,
        syncedOrders:
          action.payload === null
            ? []
            : [...state.syncedOrders, action.payload],
      };

    case "SYNECED_PROGRESS":
      return {
        ...state,
        syncingProgress: action.payload,
      };

    case "UNSYNECED_ORDERS":
      return {
        ...state,
        unSyncedOrders: [...state.unSyncedOrders, action.payload],
      };

    case userTypes.LOGOUT_USER:
      return initialstate;
    default:
      return state;
  }
};

export default orderReducer;
